import { HTTP } from '@/api/http-common'
import { HttpFunctions } from '@/api/http-functions'

export default {
  getProductByStaticUrl (staticUrl, callback) {
    HTTP.get('products/' + staticUrl).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 400) {
        console.log('Error: id is required')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  searchProducts (param, callback) {
    if (param.keyword !== undefined) {
      let queryParam = '?'
      queryParam += 'keyword=' + param.keyword
      queryParam += '&_page=' + param.page
      queryParam += '&_limit=' + param.limit
      HTTP.get('products/search' + queryParam).then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 400) {
          console.log('Error: required data is missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  getProductsByCategoryId (param, callback) {
    HTTP.get('products/category/' + param.categoryId + param.queryString).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 400) {
        console.log('Error: id is required')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/products/index.js